var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5114 9.36904L8.56935 15.254C8.25771 15.5627 7.75561 15.5627 7.44397 15.254L1.44917 9.31677C0.975733 8.85536 0.602751 8.30108 0.353637 7.68869C0.104063 7.07517 -0.015777 6.41662 0.00166375 5.75451C0.0191044 5.0924 0.173448 4.44108 0.454975 3.84155C0.736503 3.24202 1.13911 2.70727 1.63746 2.27099C2.1358 1.8347 2.71908 1.50633 3.35057 1.30654C3.98206 1.10675 4.64808 1.03988 5.30668 1.11014C5.96528 1.18039 6.6022 1.38625 7.17733 1.71476C7.47643 1.8856 7.75545 2.08768 8.00994 2.31707C8.2642 2.09046 8.54252 1.89096 8.84056 1.72242C9.41529 1.3974 10.0509 1.19451 10.7077 1.12645C11.3644 1.05839 12.0282 1.12662 12.6573 1.32688C13.2865 1.52713 13.8676 1.85509 14.3642 2.29024C14.8608 2.72539 15.2622 3.25836 15.5433 3.85579C15.8245 4.45321 15.9793 5.10224 15.9981 5.76225C16.0168 6.42225 15.8992 7.07903 15.6525 7.69148C15.4057 8.30392 15.0352 8.85884 14.5642 9.32152C14.5471 9.33828 14.5295 9.35412 14.5114 9.36904Z",
    fill: "#DD0031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.c29bf9fc2b744a1cc1a29260336a069f.svg";
export { ForwardRef as ReactComponent };